exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-absolute-layout>*{position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/AbsoluteLayout.less
// module id = 164
// module chunks = 0